import type { CasinoTournamentsPublicTournamentsQueryOrderBy } from '~/schema/public';

const getDisplayOrder = (
  activityType?: TournamentStatus,
): CasinoTournamentsPublicTournamentsQueryOrderBy => {
  switch (activityType) {
    case 'current':
      return { closeAt: 1 };
    case 'future':
      return { openAt: 1 };
    default:
      return { closeAt: -1 };
  }
};

export default getDisplayOrder;
